/**
 * True when this document arrived with prerendered HTML that React is about to hydrate.
 * Evaluated once at import time, i.e. before hydrateRoot touches #root.
 *
 * First render of a hydrating page may only depend on the URL and on the serialized state: anything read
 * from storage (session, persisted stores, dismissed banners, support widget) starts from its anonymous /
 * server value and is restored right after hydration (see restoreClientState).
 */
export const HYDRATING: boolean =
  typeof document !== 'undefined' && !!document.getElementById('root')?.hasChildNodes();
